import { styled, TextField } from '@mui/material';

export const ESignFormTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    borderRadius: '4px',
    minHeight: 56
  }
});
